(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nt-premium-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const closePanels = (except) => {
    document.querySelectorAll('.nt-header__panel[open]').forEach((panel) => {
      if (panel !== except) panel.open = false;
    });
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('.nt-header')) {
      closePanels();
      return;
    }
    const summary = event.target.closest('.nt-header summary');
    if (summary && summary.parentElement.classList.contains('nt-header__panel')) {
      closePanels(summary.parentElement);
    }
    if (summary && summary.parentElement.classList.contains('nt-header__mobile-section')) {
      summary.closest('.nt-header__mobile-panel').querySelectorAll('.nt-header__mobile-group[open]').forEach((group) => {
        group.open = false;
      });
    }
    if (summary && summary.parentElement.classList.contains('nt-header__mobile-group')) {
      summary.closest('.nt-header__mobile-panel').querySelectorAll('.nt-header__mobile-group[open]').forEach((group) => {
        if (group !== summary.parentElement) group.open = false;
      });
    }
  });
  document.addEventListener('focusin', (event) => {
    if (event.target instanceof Element && !event.target.closest('.nt-header')) closePanels();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const group = document.querySelector('.nt-header__mobile[open] .nt-header__mobile-group[open]');
    const section = document.querySelector('.nt-header__mobile[open] .nt-header__mobile-section[open]');
    const panel = group || section || document.querySelector('.nt-header__panel[open]');
    if (panel) {
      event.preventDefault();
      panel.open = false;
      panel.querySelector('summary')?.focus();
    }
  });
  window.matchMedia('(max-width: 799px)').addEventListener('change', () => closePanels());
})();

  } catch(e) { console.error(e); }
})();
})();
